import { canonicalLoomDefinitionJson } from "../features/parametric-geometry/loomAcceptedDefinitionBinding";
import {
  LOOM_TRANSITION_ACCEPTED_SCHEMA,
  LOOM_TRANSITION_SOURCE_AUTHORITY,
  LOOM_TRANSITION_UNION_ALGORITHM,
  verifyLoomAircraftTransitionAssetBuffer,
  type LoomVerifiedAircraftTransitionAsset,
} from "../features/parametric-geometry/loomAircraftTransitionAsset";
import type { LoomAuthoritativeRebuildRequestV5 } from "./loomRebuildV5";

export async function parseLoomRebuildV5Response(
  response: Response,
  buffer: ArrayBuffer,
  request: LoomAuthoritativeRebuildRequestV5,
  requiredHeader: (name: string) => string,
): Promise<{ assemblyAsset: LoomVerifiedAircraftTransitionAsset; definitionRevision: string }> {
  if (!response.headers.get("Content-Type")?.startsWith("application/vnd.loom.aircraft-occurrence-surface")
      || requiredHeader("X-Loom-Accepted-Schema") !== LOOM_TRANSITION_ACCEPTED_SCHEMA
      || requiredHeader("X-Loom-Evaluator-Id") !== request.evaluatorId
      || requiredHeader("X-Loom-Union-Algorithm-Id") !== LOOM_TRANSITION_UNION_ALGORITHM
      || requiredHeader("X-Loom-Source-Authority") !== LOOM_TRANSITION_SOURCE_AUTHORITY) {
    throw new Error("Authoritative rebuild v5 response authority is unsupported");
  }
  const assemblyAsset = await verifyLoomAircraftTransitionAssetBuffer(buffer);
  const header = assemblyAsset.header; const binding = header.definitionBinding;
  const definitionRevision = requiredHeader("X-Loom-Definition-Revision");
  if (requiredHeader("X-Loom-Geometry-Revision") !== header.surface.geometryRevision
      || requiredHeader("X-Loom-Topology-Revision") !== header.surface.topologyRevision
      || definitionRevision !== binding.definitionRevision
      || requiredHeader("X-Loom-Assembly-Topology-Revision") !== binding.assemblyTopologyRevision
      || requiredHeader("X-Loom-Pose-Revision") !== binding.poseRevision
      || requiredHeader("X-Loom-Scene-Revision") !== header.cacheReceipt.sceneRevision
      || Number(requiredHeader("X-Loom-Union-Group-Count")) !== header.unionGroups.length
      || Number(requiredHeader("X-Loom-Transition-Count")) !== header.transitions.length
      || canonicalLoomDefinitionJson(binding.definition)
        !== canonicalLoomDefinitionJson(request.definition)) {
    throw new Error("Authoritative rebuild v5 asset is not bound to the requested fairing head");
  }
  return { assemblyAsset, definitionRevision };
}
